/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicImport } from './routes/_public'
import { Route as AppImport } from './routes/_app'
import { Route as PublicIndexImport } from './routes/_public/index'
import { Route as AppTenantsImport } from './routes/_app/tenants'
import { Route as AppSettingsImport } from './routes/_app/settings'
import { Route as AppOrganizationsImport } from './routes/_app/organizations'
import { Route as AppHomeImport } from './routes/_app/home'
import { Route as AppEnvironmentsImport } from './routes/_app/environments'
import { Route as AppComponentsImport } from './routes/_app/components'
import { Route as AppClustersImport } from './routes/_app/clusters'
import { Route as AppApplicationsImport } from './routes/_app/applications'
import { Route as AppApikeysImport } from './routes/_app/apikeys'
import { Route as PublicAuthLogoutImport } from './routes/_public/auth.logout'
import { Route as PublicAuthLoginImport } from './routes/_public/auth.login'
import { Route as PublicAuthCallbackImport } from './routes/_public/auth.callback'
import { Route as AppTenantsOverviewImport } from './routes/_app/tenants.overview'
import { Route as AppTenantsActivityImport } from './routes/_app/tenants.activity'
import { Route as AppSettingsUserImport } from './routes/_app/settings.user'
import { Route as AppSettingsEventsImport } from './routes/_app/settings.events'
import { Route as AppEnvironmentsOverviewImport } from './routes/_app/environments.overview'
import { Route as AppEnvironmentsActivityImport } from './routes/_app/environments.activity'
import { Route as AppComponentsTemplatesImport } from './routes/_app/components.templates'
import { Route as AppComponentsSettingsImport } from './routes/_app/components.settings'
import { Route as AppComponentsRegistryImport } from './routes/_app/components.registry'
import { Route as AppClustersOverviewImport } from './routes/_app/clusters.overview'
import { Route as AppClustersNewImport } from './routes/_app/clusters.new'
import { Route as AppClustersCreateImport } from './routes/_app/clusters.create'
import { Route as AppClustersClusterIdImport } from './routes/_app/clusters.$clusterId'
import { Route as AppApplicationsOverviewImport } from './routes/_app/applications.overview'
import { Route as AppApplicationsDeploymentsImport } from './routes/_app/applications.deployments'
import { Route as AppApplicationsConfigurationImport } from './routes/_app/applications.configuration'
import { Route as AppAdminSsoImport } from './routes/_app/admin.sso'
import { Route as AppAdminRegistriesImport } from './routes/_app/admin.registries'
import { Route as AppAdminAuditImport } from './routes/_app/admin.audit'
import { Route as AppComponentsTemplatesRecentImport } from './routes/_app/components.templates.recent'
import { Route as AppComponentsTemplatesMineImport } from './routes/_app/components.templates.mine'
import { Route as AppApplicationsDeploymentsRecentImport } from './routes/_app/applications.deployments.recent'
import { Route as AppApplicationsDeploymentsMineImport } from './routes/_app/applications.deployments.mine'

// Create/Update Routes

const PublicRoute = PublicImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const PublicIndexRoute = PublicIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)

const AppTenantsRoute = AppTenantsImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AppRoute,
} as any)

const AppSettingsRoute = AppSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)

const AppOrganizationsRoute = AppOrganizationsImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AppRoute,
} as any)

const AppHomeRoute = AppHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)

const AppEnvironmentsRoute = AppEnvironmentsImport.update({
  id: '/environments',
  path: '/environments',
  getParentRoute: () => AppRoute,
} as any)

const AppComponentsRoute = AppComponentsImport.update({
  id: '/components',
  path: '/components',
  getParentRoute: () => AppRoute,
} as any)

const AppClustersRoute = AppClustersImport.update({
  id: '/clusters',
  path: '/clusters',
  getParentRoute: () => AppRoute,
} as any)

const AppApplicationsRoute = AppApplicationsImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => AppRoute,
} as any)

const AppApikeysRoute = AppApikeysImport.update({
  id: '/apikeys',
  path: '/apikeys',
  getParentRoute: () => AppRoute,
} as any)

const PublicAuthLogoutRoute = PublicAuthLogoutImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => PublicRoute,
} as any)

const PublicAuthLoginRoute = PublicAuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => PublicRoute,
} as any)

const PublicAuthCallbackRoute = PublicAuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => PublicRoute,
} as any)

const AppTenantsOverviewRoute = AppTenantsOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppTenantsRoute,
} as any)

const AppTenantsActivityRoute = AppTenantsActivityImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppTenantsRoute,
} as any)

const AppSettingsUserRoute = AppSettingsUserImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsEventsRoute = AppSettingsEventsImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppEnvironmentsOverviewRoute = AppEnvironmentsOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppEnvironmentsRoute,
} as any)

const AppEnvironmentsActivityRoute = AppEnvironmentsActivityImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppEnvironmentsRoute,
} as any)

const AppComponentsTemplatesRoute = AppComponentsTemplatesImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppComponentsRoute,
} as any)

const AppComponentsSettingsRoute = AppComponentsSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppComponentsRoute,
} as any).lazy(() =>
  import('./routes/_app/components.settings.lazy').then((d) => d.Route),
)

const AppComponentsRegistryRoute = AppComponentsRegistryImport.update({
  id: '/registry',
  path: '/registry',
  getParentRoute: () => AppComponentsRoute,
} as any).lazy(() =>
  import('./routes/_app/components.registry.lazy').then((d) => d.Route),
)

const AppClustersOverviewRoute = AppClustersOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppClustersRoute,
} as any).lazy(() =>
  import('./routes/_app/clusters.overview.lazy').then((d) => d.Route),
)

const AppClustersNewRoute = AppClustersNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppClustersRoute,
} as any).lazy(() =>
  import('./routes/_app/clusters.new.lazy').then((d) => d.Route),
)

const AppClustersCreateRoute = AppClustersCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppClustersRoute,
} as any).lazy(() =>
  import('./routes/_app/clusters.create.lazy').then((d) => d.Route),
)

const AppClustersClusterIdRoute = AppClustersClusterIdImport.update({
  id: '/$clusterId',
  path: '/$clusterId',
  getParentRoute: () => AppClustersRoute,
} as any).lazy(() =>
  import('./routes/_app/clusters.$clusterId.lazy').then((d) => d.Route),
)

const AppApplicationsOverviewRoute = AppApplicationsOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppApplicationsRoute,
} as any).lazy(() =>
  import('./routes/_app/applications.overview.lazy').then((d) => d.Route),
)

const AppApplicationsDeploymentsRoute = AppApplicationsDeploymentsImport.update(
  {
    id: '/deployments',
    path: '/deployments',
    getParentRoute: () => AppApplicationsRoute,
  } as any,
)

const AppApplicationsConfigurationRoute =
  AppApplicationsConfigurationImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AppApplicationsRoute,
  } as any)

const AppAdminSsoRoute = AppAdminSsoImport.update({
  id: '/admin/sso',
  path: '/admin/sso',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminRegistriesRoute = AppAdminRegistriesImport.update({
  id: '/admin/registries',
  path: '/admin/registries',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminAuditRoute = AppAdminAuditImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => AppRoute,
} as any)

const AppComponentsTemplatesRecentRoute =
  AppComponentsTemplatesRecentImport.update({
    id: '/recent',
    path: '/recent',
    getParentRoute: () => AppComponentsTemplatesRoute,
  } as any).lazy(() =>
    import('./routes/_app/components.templates.recent.lazy').then(
      (d) => d.Route,
    ),
  )

const AppComponentsTemplatesMineRoute = AppComponentsTemplatesMineImport.update(
  {
    id: '/mine',
    path: '/mine',
    getParentRoute: () => AppComponentsTemplatesRoute,
  } as any,
).lazy(() =>
  import('./routes/_app/components.templates.mine.lazy').then((d) => d.Route),
)

const AppApplicationsDeploymentsRecentRoute =
  AppApplicationsDeploymentsRecentImport.update({
    id: '/recent',
    path: '/recent',
    getParentRoute: () => AppApplicationsDeploymentsRoute,
  } as any).lazy(() =>
    import('./routes/_app/applications.deployments.recent.lazy').then(
      (d) => d.Route,
    ),
  )

const AppApplicationsDeploymentsMineRoute =
  AppApplicationsDeploymentsMineImport.update({
    id: '/mine',
    path: '/mine',
    getParentRoute: () => AppApplicationsDeploymentsRoute,
  } as any).lazy(() =>
    import('./routes/_app/applications.deployments.mine.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicImport
      parentRoute: typeof rootRoute
    }
    '/_app/apikeys': {
      id: '/_app/apikeys'
      path: '/apikeys'
      fullPath: '/apikeys'
      preLoaderRoute: typeof AppApikeysImport
      parentRoute: typeof AppImport
    }
    '/_app/applications': {
      id: '/_app/applications'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof AppApplicationsImport
      parentRoute: typeof AppImport
    }
    '/_app/clusters': {
      id: '/_app/clusters'
      path: '/clusters'
      fullPath: '/clusters'
      preLoaderRoute: typeof AppClustersImport
      parentRoute: typeof AppImport
    }
    '/_app/components': {
      id: '/_app/components'
      path: '/components'
      fullPath: '/components'
      preLoaderRoute: typeof AppComponentsImport
      parentRoute: typeof AppImport
    }
    '/_app/environments': {
      id: '/_app/environments'
      path: '/environments'
      fullPath: '/environments'
      preLoaderRoute: typeof AppEnvironmentsImport
      parentRoute: typeof AppImport
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeImport
      parentRoute: typeof AppImport
    }
    '/_app/organizations': {
      id: '/_app/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AppOrganizationsImport
      parentRoute: typeof AppImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsImport
      parentRoute: typeof AppImport
    }
    '/_app/tenants': {
      id: '/_app/tenants'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof AppTenantsImport
      parentRoute: typeof AppImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexImport
      parentRoute: typeof PublicImport
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditImport
      parentRoute: typeof AppImport
    }
    '/_app/admin/registries': {
      id: '/_app/admin/registries'
      path: '/admin/registries'
      fullPath: '/admin/registries'
      preLoaderRoute: typeof AppAdminRegistriesImport
      parentRoute: typeof AppImport
    }
    '/_app/admin/sso': {
      id: '/_app/admin/sso'
      path: '/admin/sso'
      fullPath: '/admin/sso'
      preLoaderRoute: typeof AppAdminSsoImport
      parentRoute: typeof AppImport
    }
    '/_app/applications/configuration': {
      id: '/_app/applications/configuration'
      path: '/configuration'
      fullPath: '/applications/configuration'
      preLoaderRoute: typeof AppApplicationsConfigurationImport
      parentRoute: typeof AppApplicationsImport
    }
    '/_app/applications/deployments': {
      id: '/_app/applications/deployments'
      path: '/deployments'
      fullPath: '/applications/deployments'
      preLoaderRoute: typeof AppApplicationsDeploymentsImport
      parentRoute: typeof AppApplicationsImport
    }
    '/_app/applications/overview': {
      id: '/_app/applications/overview'
      path: '/overview'
      fullPath: '/applications/overview'
      preLoaderRoute: typeof AppApplicationsOverviewImport
      parentRoute: typeof AppApplicationsImport
    }
    '/_app/clusters/$clusterId': {
      id: '/_app/clusters/$clusterId'
      path: '/$clusterId'
      fullPath: '/clusters/$clusterId'
      preLoaderRoute: typeof AppClustersClusterIdImport
      parentRoute: typeof AppClustersImport
    }
    '/_app/clusters/create': {
      id: '/_app/clusters/create'
      path: '/create'
      fullPath: '/clusters/create'
      preLoaderRoute: typeof AppClustersCreateImport
      parentRoute: typeof AppClustersImport
    }
    '/_app/clusters/new': {
      id: '/_app/clusters/new'
      path: '/new'
      fullPath: '/clusters/new'
      preLoaderRoute: typeof AppClustersNewImport
      parentRoute: typeof AppClustersImport
    }
    '/_app/clusters/overview': {
      id: '/_app/clusters/overview'
      path: '/overview'
      fullPath: '/clusters/overview'
      preLoaderRoute: typeof AppClustersOverviewImport
      parentRoute: typeof AppClustersImport
    }
    '/_app/components/registry': {
      id: '/_app/components/registry'
      path: '/registry'
      fullPath: '/components/registry'
      preLoaderRoute: typeof AppComponentsRegistryImport
      parentRoute: typeof AppComponentsImport
    }
    '/_app/components/settings': {
      id: '/_app/components/settings'
      path: '/settings'
      fullPath: '/components/settings'
      preLoaderRoute: typeof AppComponentsSettingsImport
      parentRoute: typeof AppComponentsImport
    }
    '/_app/components/templates': {
      id: '/_app/components/templates'
      path: '/templates'
      fullPath: '/components/templates'
      preLoaderRoute: typeof AppComponentsTemplatesImport
      parentRoute: typeof AppComponentsImport
    }
    '/_app/environments/activity': {
      id: '/_app/environments/activity'
      path: '/activity'
      fullPath: '/environments/activity'
      preLoaderRoute: typeof AppEnvironmentsActivityImport
      parentRoute: typeof AppEnvironmentsImport
    }
    '/_app/environments/overview': {
      id: '/_app/environments/overview'
      path: '/overview'
      fullPath: '/environments/overview'
      preLoaderRoute: typeof AppEnvironmentsOverviewImport
      parentRoute: typeof AppEnvironmentsImport
    }
    '/_app/settings/events': {
      id: '/_app/settings/events'
      path: '/events'
      fullPath: '/settings/events'
      preLoaderRoute: typeof AppSettingsEventsImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/settings/user': {
      id: '/_app/settings/user'
      path: '/user'
      fullPath: '/settings/user'
      preLoaderRoute: typeof AppSettingsUserImport
      parentRoute: typeof AppSettingsImport
    }
    '/_app/tenants/activity': {
      id: '/_app/tenants/activity'
      path: '/activity'
      fullPath: '/tenants/activity'
      preLoaderRoute: typeof AppTenantsActivityImport
      parentRoute: typeof AppTenantsImport
    }
    '/_app/tenants/overview': {
      id: '/_app/tenants/overview'
      path: '/overview'
      fullPath: '/tenants/overview'
      preLoaderRoute: typeof AppTenantsOverviewImport
      parentRoute: typeof AppTenantsImport
    }
    '/_public/auth/callback': {
      id: '/_public/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof PublicAuthCallbackImport
      parentRoute: typeof PublicImport
    }
    '/_public/auth/login': {
      id: '/_public/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof PublicAuthLoginImport
      parentRoute: typeof PublicImport
    }
    '/_public/auth/logout': {
      id: '/_public/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof PublicAuthLogoutImport
      parentRoute: typeof PublicImport
    }
    '/_app/applications/deployments/mine': {
      id: '/_app/applications/deployments/mine'
      path: '/mine'
      fullPath: '/applications/deployments/mine'
      preLoaderRoute: typeof AppApplicationsDeploymentsMineImport
      parentRoute: typeof AppApplicationsDeploymentsImport
    }
    '/_app/applications/deployments/recent': {
      id: '/_app/applications/deployments/recent'
      path: '/recent'
      fullPath: '/applications/deployments/recent'
      preLoaderRoute: typeof AppApplicationsDeploymentsRecentImport
      parentRoute: typeof AppApplicationsDeploymentsImport
    }
    '/_app/components/templates/mine': {
      id: '/_app/components/templates/mine'
      path: '/mine'
      fullPath: '/components/templates/mine'
      preLoaderRoute: typeof AppComponentsTemplatesMineImport
      parentRoute: typeof AppComponentsTemplatesImport
    }
    '/_app/components/templates/recent': {
      id: '/_app/components/templates/recent'
      path: '/recent'
      fullPath: '/components/templates/recent'
      preLoaderRoute: typeof AppComponentsTemplatesRecentImport
      parentRoute: typeof AppComponentsTemplatesImport
    }
  }
}

// Create and export the route tree

interface AppApplicationsDeploymentsRouteChildren {
  AppApplicationsDeploymentsMineRoute: typeof AppApplicationsDeploymentsMineRoute
  AppApplicationsDeploymentsRecentRoute: typeof AppApplicationsDeploymentsRecentRoute
}

const AppApplicationsDeploymentsRouteChildren: AppApplicationsDeploymentsRouteChildren =
  {
    AppApplicationsDeploymentsMineRoute: AppApplicationsDeploymentsMineRoute,
    AppApplicationsDeploymentsRecentRoute:
      AppApplicationsDeploymentsRecentRoute,
  }

const AppApplicationsDeploymentsRouteWithChildren =
  AppApplicationsDeploymentsRoute._addFileChildren(
    AppApplicationsDeploymentsRouteChildren,
  )

interface AppApplicationsRouteChildren {
  AppApplicationsConfigurationRoute: typeof AppApplicationsConfigurationRoute
  AppApplicationsDeploymentsRoute: typeof AppApplicationsDeploymentsRouteWithChildren
  AppApplicationsOverviewRoute: typeof AppApplicationsOverviewRoute
}

const AppApplicationsRouteChildren: AppApplicationsRouteChildren = {
  AppApplicationsConfigurationRoute: AppApplicationsConfigurationRoute,
  AppApplicationsDeploymentsRoute: AppApplicationsDeploymentsRouteWithChildren,
  AppApplicationsOverviewRoute: AppApplicationsOverviewRoute,
}

const AppApplicationsRouteWithChildren = AppApplicationsRoute._addFileChildren(
  AppApplicationsRouteChildren,
)

interface AppClustersRouteChildren {
  AppClustersClusterIdRoute: typeof AppClustersClusterIdRoute
  AppClustersCreateRoute: typeof AppClustersCreateRoute
  AppClustersNewRoute: typeof AppClustersNewRoute
  AppClustersOverviewRoute: typeof AppClustersOverviewRoute
}

const AppClustersRouteChildren: AppClustersRouteChildren = {
  AppClustersClusterIdRoute: AppClustersClusterIdRoute,
  AppClustersCreateRoute: AppClustersCreateRoute,
  AppClustersNewRoute: AppClustersNewRoute,
  AppClustersOverviewRoute: AppClustersOverviewRoute,
}

const AppClustersRouteWithChildren = AppClustersRoute._addFileChildren(
  AppClustersRouteChildren,
)

interface AppComponentsTemplatesRouteChildren {
  AppComponentsTemplatesMineRoute: typeof AppComponentsTemplatesMineRoute
  AppComponentsTemplatesRecentRoute: typeof AppComponentsTemplatesRecentRoute
}

const AppComponentsTemplatesRouteChildren: AppComponentsTemplatesRouteChildren =
  {
    AppComponentsTemplatesMineRoute: AppComponentsTemplatesMineRoute,
    AppComponentsTemplatesRecentRoute: AppComponentsTemplatesRecentRoute,
  }

const AppComponentsTemplatesRouteWithChildren =
  AppComponentsTemplatesRoute._addFileChildren(
    AppComponentsTemplatesRouteChildren,
  )

interface AppComponentsRouteChildren {
  AppComponentsRegistryRoute: typeof AppComponentsRegistryRoute
  AppComponentsSettingsRoute: typeof AppComponentsSettingsRoute
  AppComponentsTemplatesRoute: typeof AppComponentsTemplatesRouteWithChildren
}

const AppComponentsRouteChildren: AppComponentsRouteChildren = {
  AppComponentsRegistryRoute: AppComponentsRegistryRoute,
  AppComponentsSettingsRoute: AppComponentsSettingsRoute,
  AppComponentsTemplatesRoute: AppComponentsTemplatesRouteWithChildren,
}

const AppComponentsRouteWithChildren = AppComponentsRoute._addFileChildren(
  AppComponentsRouteChildren,
)

interface AppEnvironmentsRouteChildren {
  AppEnvironmentsActivityRoute: typeof AppEnvironmentsActivityRoute
  AppEnvironmentsOverviewRoute: typeof AppEnvironmentsOverviewRoute
}

const AppEnvironmentsRouteChildren: AppEnvironmentsRouteChildren = {
  AppEnvironmentsActivityRoute: AppEnvironmentsActivityRoute,
  AppEnvironmentsOverviewRoute: AppEnvironmentsOverviewRoute,
}

const AppEnvironmentsRouteWithChildren = AppEnvironmentsRoute._addFileChildren(
  AppEnvironmentsRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsEventsRoute: typeof AppSettingsEventsRoute
  AppSettingsUserRoute: typeof AppSettingsUserRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsEventsRoute: AppSettingsEventsRoute,
  AppSettingsUserRoute: AppSettingsUserRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppTenantsRouteChildren {
  AppTenantsActivityRoute: typeof AppTenantsActivityRoute
  AppTenantsOverviewRoute: typeof AppTenantsOverviewRoute
}

const AppTenantsRouteChildren: AppTenantsRouteChildren = {
  AppTenantsActivityRoute: AppTenantsActivityRoute,
  AppTenantsOverviewRoute: AppTenantsOverviewRoute,
}

const AppTenantsRouteWithChildren = AppTenantsRoute._addFileChildren(
  AppTenantsRouteChildren,
)

interface AppRouteChildren {
  AppApikeysRoute: typeof AppApikeysRoute
  AppApplicationsRoute: typeof AppApplicationsRouteWithChildren
  AppClustersRoute: typeof AppClustersRouteWithChildren
  AppComponentsRoute: typeof AppComponentsRouteWithChildren
  AppEnvironmentsRoute: typeof AppEnvironmentsRouteWithChildren
  AppHomeRoute: typeof AppHomeRoute
  AppOrganizationsRoute: typeof AppOrganizationsRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTenantsRoute: typeof AppTenantsRouteWithChildren
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminRegistriesRoute: typeof AppAdminRegistriesRoute
  AppAdminSsoRoute: typeof AppAdminSsoRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppApikeysRoute: AppApikeysRoute,
  AppApplicationsRoute: AppApplicationsRouteWithChildren,
  AppClustersRoute: AppClustersRouteWithChildren,
  AppComponentsRoute: AppComponentsRouteWithChildren,
  AppEnvironmentsRoute: AppEnvironmentsRouteWithChildren,
  AppHomeRoute: AppHomeRoute,
  AppOrganizationsRoute: AppOrganizationsRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTenantsRoute: AppTenantsRouteWithChildren,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminRegistriesRoute: AppAdminRegistriesRoute,
  AppAdminSsoRoute: AppAdminSsoRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PublicRouteChildren {
  PublicIndexRoute: typeof PublicIndexRoute
  PublicAuthCallbackRoute: typeof PublicAuthCallbackRoute
  PublicAuthLoginRoute: typeof PublicAuthLoginRoute
  PublicAuthLogoutRoute: typeof PublicAuthLogoutRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicIndexRoute: PublicIndexRoute,
  PublicAuthCallbackRoute: PublicAuthCallbackRoute,
  PublicAuthLoginRoute: PublicAuthLoginRoute,
  PublicAuthLogoutRoute: PublicAuthLogoutRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof PublicRouteWithChildren
  '/apikeys': typeof AppApikeysRoute
  '/applications': typeof AppApplicationsRouteWithChildren
  '/clusters': typeof AppClustersRouteWithChildren
  '/components': typeof AppComponentsRouteWithChildren
  '/environments': typeof AppEnvironmentsRouteWithChildren
  '/home': typeof AppHomeRoute
  '/organizations': typeof AppOrganizationsRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/tenants': typeof AppTenantsRouteWithChildren
  '/': typeof PublicIndexRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/registries': typeof AppAdminRegistriesRoute
  '/admin/sso': typeof AppAdminSsoRoute
  '/applications/configuration': typeof AppApplicationsConfigurationRoute
  '/applications/deployments': typeof AppApplicationsDeploymentsRouteWithChildren
  '/applications/overview': typeof AppApplicationsOverviewRoute
  '/clusters/$clusterId': typeof AppClustersClusterIdRoute
  '/clusters/create': typeof AppClustersCreateRoute
  '/clusters/new': typeof AppClustersNewRoute
  '/clusters/overview': typeof AppClustersOverviewRoute
  '/components/registry': typeof AppComponentsRegistryRoute
  '/components/settings': typeof AppComponentsSettingsRoute
  '/components/templates': typeof AppComponentsTemplatesRouteWithChildren
  '/environments/activity': typeof AppEnvironmentsActivityRoute
  '/environments/overview': typeof AppEnvironmentsOverviewRoute
  '/settings/events': typeof AppSettingsEventsRoute
  '/settings/user': typeof AppSettingsUserRoute
  '/tenants/activity': typeof AppTenantsActivityRoute
  '/tenants/overview': typeof AppTenantsOverviewRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/auth/login': typeof PublicAuthLoginRoute
  '/auth/logout': typeof PublicAuthLogoutRoute
  '/applications/deployments/mine': typeof AppApplicationsDeploymentsMineRoute
  '/applications/deployments/recent': typeof AppApplicationsDeploymentsRecentRoute
  '/components/templates/mine': typeof AppComponentsTemplatesMineRoute
  '/components/templates/recent': typeof AppComponentsTemplatesRecentRoute
}

export interface FileRoutesByTo {
  '': typeof AppRouteWithChildren
  '/apikeys': typeof AppApikeysRoute
  '/applications': typeof AppApplicationsRouteWithChildren
  '/clusters': typeof AppClustersRouteWithChildren
  '/components': typeof AppComponentsRouteWithChildren
  '/environments': typeof AppEnvironmentsRouteWithChildren
  '/home': typeof AppHomeRoute
  '/organizations': typeof AppOrganizationsRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/tenants': typeof AppTenantsRouteWithChildren
  '/': typeof PublicIndexRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/registries': typeof AppAdminRegistriesRoute
  '/admin/sso': typeof AppAdminSsoRoute
  '/applications/configuration': typeof AppApplicationsConfigurationRoute
  '/applications/deployments': typeof AppApplicationsDeploymentsRouteWithChildren
  '/applications/overview': typeof AppApplicationsOverviewRoute
  '/clusters/$clusterId': typeof AppClustersClusterIdRoute
  '/clusters/create': typeof AppClustersCreateRoute
  '/clusters/new': typeof AppClustersNewRoute
  '/clusters/overview': typeof AppClustersOverviewRoute
  '/components/registry': typeof AppComponentsRegistryRoute
  '/components/settings': typeof AppComponentsSettingsRoute
  '/components/templates': typeof AppComponentsTemplatesRouteWithChildren
  '/environments/activity': typeof AppEnvironmentsActivityRoute
  '/environments/overview': typeof AppEnvironmentsOverviewRoute
  '/settings/events': typeof AppSettingsEventsRoute
  '/settings/user': typeof AppSettingsUserRoute
  '/tenants/activity': typeof AppTenantsActivityRoute
  '/tenants/overview': typeof AppTenantsOverviewRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/auth/login': typeof PublicAuthLoginRoute
  '/auth/logout': typeof PublicAuthLogoutRoute
  '/applications/deployments/mine': typeof AppApplicationsDeploymentsMineRoute
  '/applications/deployments/recent': typeof AppApplicationsDeploymentsRecentRoute
  '/components/templates/mine': typeof AppComponentsTemplatesMineRoute
  '/components/templates/recent': typeof AppComponentsTemplatesRecentRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_app/apikeys': typeof AppApikeysRoute
  '/_app/applications': typeof AppApplicationsRouteWithChildren
  '/_app/clusters': typeof AppClustersRouteWithChildren
  '/_app/components': typeof AppComponentsRouteWithChildren
  '/_app/environments': typeof AppEnvironmentsRouteWithChildren
  '/_app/home': typeof AppHomeRoute
  '/_app/organizations': typeof AppOrganizationsRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/tenants': typeof AppTenantsRouteWithChildren
  '/_public/': typeof PublicIndexRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/registries': typeof AppAdminRegistriesRoute
  '/_app/admin/sso': typeof AppAdminSsoRoute
  '/_app/applications/configuration': typeof AppApplicationsConfigurationRoute
  '/_app/applications/deployments': typeof AppApplicationsDeploymentsRouteWithChildren
  '/_app/applications/overview': typeof AppApplicationsOverviewRoute
  '/_app/clusters/$clusterId': typeof AppClustersClusterIdRoute
  '/_app/clusters/create': typeof AppClustersCreateRoute
  '/_app/clusters/new': typeof AppClustersNewRoute
  '/_app/clusters/overview': typeof AppClustersOverviewRoute
  '/_app/components/registry': typeof AppComponentsRegistryRoute
  '/_app/components/settings': typeof AppComponentsSettingsRoute
  '/_app/components/templates': typeof AppComponentsTemplatesRouteWithChildren
  '/_app/environments/activity': typeof AppEnvironmentsActivityRoute
  '/_app/environments/overview': typeof AppEnvironmentsOverviewRoute
  '/_app/settings/events': typeof AppSettingsEventsRoute
  '/_app/settings/user': typeof AppSettingsUserRoute
  '/_app/tenants/activity': typeof AppTenantsActivityRoute
  '/_app/tenants/overview': typeof AppTenantsOverviewRoute
  '/_public/auth/callback': typeof PublicAuthCallbackRoute
  '/_public/auth/login': typeof PublicAuthLoginRoute
  '/_public/auth/logout': typeof PublicAuthLogoutRoute
  '/_app/applications/deployments/mine': typeof AppApplicationsDeploymentsMineRoute
  '/_app/applications/deployments/recent': typeof AppApplicationsDeploymentsRecentRoute
  '/_app/components/templates/mine': typeof AppComponentsTemplatesMineRoute
  '/_app/components/templates/recent': typeof AppComponentsTemplatesRecentRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/apikeys'
    | '/applications'
    | '/clusters'
    | '/components'
    | '/environments'
    | '/home'
    | '/organizations'
    | '/settings'
    | '/tenants'
    | '/'
    | '/admin/audit'
    | '/admin/registries'
    | '/admin/sso'
    | '/applications/configuration'
    | '/applications/deployments'
    | '/applications/overview'
    | '/clusters/$clusterId'
    | '/clusters/create'
    | '/clusters/new'
    | '/clusters/overview'
    | '/components/registry'
    | '/components/settings'
    | '/components/templates'
    | '/environments/activity'
    | '/environments/overview'
    | '/settings/events'
    | '/settings/user'
    | '/tenants/activity'
    | '/tenants/overview'
    | '/auth/callback'
    | '/auth/login'
    | '/auth/logout'
    | '/applications/deployments/mine'
    | '/applications/deployments/recent'
    | '/components/templates/mine'
    | '/components/templates/recent'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/apikeys'
    | '/applications'
    | '/clusters'
    | '/components'
    | '/environments'
    | '/home'
    | '/organizations'
    | '/settings'
    | '/tenants'
    | '/'
    | '/admin/audit'
    | '/admin/registries'
    | '/admin/sso'
    | '/applications/configuration'
    | '/applications/deployments'
    | '/applications/overview'
    | '/clusters/$clusterId'
    | '/clusters/create'
    | '/clusters/new'
    | '/clusters/overview'
    | '/components/registry'
    | '/components/settings'
    | '/components/templates'
    | '/environments/activity'
    | '/environments/overview'
    | '/settings/events'
    | '/settings/user'
    | '/tenants/activity'
    | '/tenants/overview'
    | '/auth/callback'
    | '/auth/login'
    | '/auth/logout'
    | '/applications/deployments/mine'
    | '/applications/deployments/recent'
    | '/components/templates/mine'
    | '/components/templates/recent'
  id:
    | '__root__'
    | '/_app'
    | '/_public'
    | '/_app/apikeys'
    | '/_app/applications'
    | '/_app/clusters'
    | '/_app/components'
    | '/_app/environments'
    | '/_app/home'
    | '/_app/organizations'
    | '/_app/settings'
    | '/_app/tenants'
    | '/_public/'
    | '/_app/admin/audit'
    | '/_app/admin/registries'
    | '/_app/admin/sso'
    | '/_app/applications/configuration'
    | '/_app/applications/deployments'
    | '/_app/applications/overview'
    | '/_app/clusters/$clusterId'
    | '/_app/clusters/create'
    | '/_app/clusters/new'
    | '/_app/clusters/overview'
    | '/_app/components/registry'
    | '/_app/components/settings'
    | '/_app/components/templates'
    | '/_app/environments/activity'
    | '/_app/environments/overview'
    | '/_app/settings/events'
    | '/_app/settings/user'
    | '/_app/tenants/activity'
    | '/_app/tenants/overview'
    | '/_public/auth/callback'
    | '/_public/auth/login'
    | '/_public/auth/logout'
    | '/_app/applications/deployments/mine'
    | '/_app/applications/deployments/recent'
    | '/_app/components/templates/mine'
    | '/_app/components/templates/recent'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/_public"
      ]
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/apikeys",
        "/_app/applications",
        "/_app/clusters",
        "/_app/components",
        "/_app/environments",
        "/_app/home",
        "/_app/organizations",
        "/_app/settings",
        "/_app/tenants",
        "/_app/admin/audit",
        "/_app/admin/registries",
        "/_app/admin/sso"
      ]
    },
    "/_public": {
      "filePath": "_public.tsx",
      "children": [
        "/_public/",
        "/_public/auth/callback",
        "/_public/auth/login",
        "/_public/auth/logout"
      ]
    },
    "/_app/apikeys": {
      "filePath": "_app/apikeys.tsx",
      "parent": "/_app"
    },
    "/_app/applications": {
      "filePath": "_app/applications.tsx",
      "parent": "/_app",
      "children": [
        "/_app/applications/configuration",
        "/_app/applications/deployments",
        "/_app/applications/overview"
      ]
    },
    "/_app/clusters": {
      "filePath": "_app/clusters.tsx",
      "parent": "/_app",
      "children": [
        "/_app/clusters/$clusterId",
        "/_app/clusters/create",
        "/_app/clusters/new",
        "/_app/clusters/overview"
      ]
    },
    "/_app/components": {
      "filePath": "_app/components.tsx",
      "parent": "/_app",
      "children": [
        "/_app/components/registry",
        "/_app/components/settings",
        "/_app/components/templates"
      ]
    },
    "/_app/environments": {
      "filePath": "_app/environments.tsx",
      "parent": "/_app",
      "children": [
        "/_app/environments/activity",
        "/_app/environments/overview"
      ]
    },
    "/_app/home": {
      "filePath": "_app/home.tsx",
      "parent": "/_app"
    },
    "/_app/organizations": {
      "filePath": "_app/organizations.tsx",
      "parent": "/_app"
    },
    "/_app/settings": {
      "filePath": "_app/settings.tsx",
      "parent": "/_app",
      "children": [
        "/_app/settings/events",
        "/_app/settings/user"
      ]
    },
    "/_app/tenants": {
      "filePath": "_app/tenants.tsx",
      "parent": "/_app",
      "children": [
        "/_app/tenants/activity",
        "/_app/tenants/overview"
      ]
    },
    "/_public/": {
      "filePath": "_public/index.tsx",
      "parent": "/_public"
    },
    "/_app/admin/audit": {
      "filePath": "_app/admin.audit.tsx",
      "parent": "/_app"
    },
    "/_app/admin/registries": {
      "filePath": "_app/admin.registries.tsx",
      "parent": "/_app"
    },
    "/_app/admin/sso": {
      "filePath": "_app/admin.sso.tsx",
      "parent": "/_app"
    },
    "/_app/applications/configuration": {
      "filePath": "_app/applications.configuration.tsx",
      "parent": "/_app/applications"
    },
    "/_app/applications/deployments": {
      "filePath": "_app/applications.deployments.tsx",
      "parent": "/_app/applications",
      "children": [
        "/_app/applications/deployments/mine",
        "/_app/applications/deployments/recent"
      ]
    },
    "/_app/applications/overview": {
      "filePath": "_app/applications.overview.tsx",
      "parent": "/_app/applications"
    },
    "/_app/clusters/$clusterId": {
      "filePath": "_app/clusters.$clusterId.tsx",
      "parent": "/_app/clusters"
    },
    "/_app/clusters/create": {
      "filePath": "_app/clusters.create.tsx",
      "parent": "/_app/clusters"
    },
    "/_app/clusters/new": {
      "filePath": "_app/clusters.new.tsx",
      "parent": "/_app/clusters"
    },
    "/_app/clusters/overview": {
      "filePath": "_app/clusters.overview.tsx",
      "parent": "/_app/clusters"
    },
    "/_app/components/registry": {
      "filePath": "_app/components.registry.tsx",
      "parent": "/_app/components"
    },
    "/_app/components/settings": {
      "filePath": "_app/components.settings.tsx",
      "parent": "/_app/components"
    },
    "/_app/components/templates": {
      "filePath": "_app/components.templates.tsx",
      "parent": "/_app/components",
      "children": [
        "/_app/components/templates/mine",
        "/_app/components/templates/recent"
      ]
    },
    "/_app/environments/activity": {
      "filePath": "_app/environments.activity.tsx",
      "parent": "/_app/environments"
    },
    "/_app/environments/overview": {
      "filePath": "_app/environments.overview.tsx",
      "parent": "/_app/environments"
    },
    "/_app/settings/events": {
      "filePath": "_app/settings.events.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/user": {
      "filePath": "_app/settings.user.tsx",
      "parent": "/_app/settings"
    },
    "/_app/tenants/activity": {
      "filePath": "_app/tenants.activity.tsx",
      "parent": "/_app/tenants"
    },
    "/_app/tenants/overview": {
      "filePath": "_app/tenants.overview.tsx",
      "parent": "/_app/tenants"
    },
    "/_public/auth/callback": {
      "filePath": "_public/auth.callback.tsx",
      "parent": "/_public"
    },
    "/_public/auth/login": {
      "filePath": "_public/auth.login.tsx",
      "parent": "/_public"
    },
    "/_public/auth/logout": {
      "filePath": "_public/auth.logout.tsx",
      "parent": "/_public"
    },
    "/_app/applications/deployments/mine": {
      "filePath": "_app/applications.deployments.mine.tsx",
      "parent": "/_app/applications/deployments"
    },
    "/_app/applications/deployments/recent": {
      "filePath": "_app/applications.deployments.recent.tsx",
      "parent": "/_app/applications/deployments"
    },
    "/_app/components/templates/mine": {
      "filePath": "_app/components.templates.mine.tsx",
      "parent": "/_app/components/templates"
    },
    "/_app/components/templates/recent": {
      "filePath": "_app/components.templates.recent.tsx",
      "parent": "/_app/components/templates"
    }
  }
}
ROUTE_MANIFEST_END */
